<template>
  <div class="payment-container">
    <!-- 基本信息 -->
    <div class="section basic-info">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">基本信息</span>
      </div>
      <div class="section-content">
        <div class="info-grid">
          <div class="info-item">
            <span class="label">姓名:</span>
            <span class="value">{{ studentInfo.name}}</span>
          </div>
          <div class="info-item">
            <span class="label">性别:</span>
            <span class="value">{{ studentInfo.gender | f('sex') }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业:</span>
            <span class="value">{{ studentInfo.specialtyCode+'-'+studentInfo.specialtyName }}</span>
          </div>
          <div class="info-item">
            <span class="label">专业层次:</span>
            <span class="value">{{ studentInfo.eduLevel | f('edulevel') }}</span>
          </div>
          <div class="info-item">
            <span class="label">证件号码:</span>
            <span class="value">{{ studentInfo.idCardNumber }}</span>
          </div>
          <div class="info-item">
            <span class="label">助学点:</span>
            <span class="value">{{ studentInfo.orgCode+'-'+studentInfo.orgName }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 缴费 -->
    <div class="section payment-section">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">缴费</span>
      </div>
      <div class="section-content">
        <el-table
          :data="feeList"
          border
          style="width: 100%"
          :header-cell-style="{ background: '#E9EFF9', color: '#1a1a1a', fontWeight: '500' }"
        >
          <el-table-column width="60" align="center">
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                :disabled="scope.row.status === 'YZF' || !canPayYear(scope.row)"
                @change="(val) => handleCheckboxChange(val, scope.row)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="yearTime" label="助学年份" align="center"></el-table-column>
          <el-table-column label="费用标准 (元/年)" align="center">
            <template slot-scope="scope">
              {{ Number(scope.row.money) == 0 ? '免费' : scope.row.money }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 'YZF'" class="YZF-text">{{ Number(scope.row.money) == 0 ? '' : '已缴' }}</span>
              <span v-else-if="!canPayYear(scope.row)" class="disabled-pay-text">未缴</span>
              <a v-else href="javascript:void(0)" class="pay-link" @click="handleGoToPay(scope.row)">缴费</a>
            </template>
          </el-table-column>
        </el-table>

        <!-- 合计金额 -->
        <div class="total-amount">
          <span class="total-label">合计:</span>
          <span class="total-value">{{ totalAmount }}元</span>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="action-buttons d-flex d-flex-middle d-flex-center">
      <!-- <el-button class="download-btn" @click="handleDownloadNotice">下载入学通知书</el-button> -->
      <el-button class="pay-btn" @click="handlePay">缴费</el-button>
    </div>
    
    <!-- 支付弹窗 -->
    <PayDialog ref="payDialog" @refresh="handleRefresh" />
  </div>
</template>

<script>
import PayDialog from './PayDialog.vue'

export default {
  name: 'Payment',
  components: {
    PayDialog
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      studentInfo: {},
      feeList: [],
    }
  },
  created() {
    this.loadStudentInfo()
    this.loadPaymentData()
  },
  computed: {
    totalAmount() {
      return this.feeList
        .filter(item => item.checked && item.status !== 'YZF')
        .reduce((sum, item) => sum + (item.money || 0), 0)
    }
  },
  methods: {
    getYearNumber(yearTime) {
      if (yearTime === null || yearTime === undefined) return null
      const str = String(yearTime)
      const numberMatch = str.match(/\d+/)
      if (numberMatch) return Number(numberMatch[0])
      const chineseMap = { 一: 1, 二: 2, 三: 3, 四: 4, 五: 5, 六: 6, 七: 7, 八: 8, 九: 9 }
      const chineseMatch = str.match(/第([一二三四五六七八九])/)
      if (chineseMatch && chineseMap[chineseMatch[1]]) return chineseMap[chineseMatch[1]]
      return null
    },
    canPayYear(row) {
      const currentYear = this.getYearNumber(row.yearTime)
      if (!currentYear || currentYear <= 1) return true
      return this.feeList.every(item => {
        const y = this.getYearNumber(item.yearTime)
        if (y === null || y >= currentYear) return true
        return item.status === 'YZF'
      })
    },
    loadStudentInfo() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?studentId='+this.$route.query.studentId+'&target_id=22b542ab707097').then(res => {
        this.studentInfo = res
      })

    },
    loadPaymentData() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/getFee',{studentId: this.$route.query.studentId}).then(res => {
        // 初始化数据时添加 checked 属性
        this.feeList = res.records.map(item => ({
          ...item,
          checked: item.checked || false,
          status: Number(item.money) == 0 ? 'YZF' : item.status
        }))
      })
    },
    handleCheckboxChange(checked, row) {
      // 只允许选一个：当选中某个选项时，取消其他所有选项
      if (checked) {
        // 先取消所有其他选项
        this.feeList.forEach(item => {
          if (item !== row) {
            this.$set(item, 'checked', false)
          }
        })
        // 确保当前选项为选中状态
        this.$set(row, 'checked', true)
      }
    },
    handleGoToPay(row) {
      if (row.orderId) {
        this.$http.get(this.MOCK_PREFIX + '/student/pc/studyFee/order/getDetail/' + row.orderId).then(res => {
          this.$refs.payDialog.open(res)
        })
      } else {
        // 创建新订单
        this.$http.post(this.MOCK_PREFIX + '/student/pc/studyFee/order/create2/' + row.yearTime,{
          studentId: this.$route.query.studentId
        }).then(res => {
          this.$refs.payDialog.open(res)
        })
      }
    },
    handleDownloadNotice() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/getNoticeUrl?studentId='+this.$route.query.studentId).then(res => {
        if(res){
          window.open(res,'_blank')
        }
      })
    },
    handlePay() {
      // 缴费
      const selectedItems = this.feeList.filter(item => item.checked && item.status !== 'YZF')
      if (selectedItems.length === 0) {
        this.$message.warning('请选择要缴费的项目')
        return
      }
      
      const selectedItem = selectedItems[0]

      if (selectedItem.orderId) {
        // 如果已有订单，直接打开支付弹窗
        this.$http.get(this.MOCK_PREFIX + '/student/pc/studyFee/order/getDetail/' + selectedItem.orderId).then(res => {
          this.$refs.payDialog.open(res)
        })
      } else {
        // 创建新订单
        this.$http.post(this.MOCK_PREFIX + '/student/pc/studyFee/order/create2/' + selectedItem.yearTime, {
          studentId: this.$route.query.studentId
        }).then(res => {
          this.$refs.payDialog.open(res)
        })
      }
    },
    handleRefresh() {
      // 支付成功后刷新数据
      this.loadPaymentData()
      this.$message.success('支付成功')
    },
    handlePrev() {
      this.$emit('prev-step')
    },
    handleSubmit() {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-container {
  width: 100%;
  padding: 30px 0;
}

.section {
  margin-bottom: 30px;

  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .title-bar {
      display: inline-block;
      width: 4px;
      height: 18px;
      background: #1890ff;
      margin-right: 10px;
      border-radius: 2px;
    }

    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
    }
  }

  .section-content {
    background: #fff;
  }
}

.basic-info {
  .section-content {
    padding: 20px 0;
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px 50px;
    padding: 0 20px;

    .info-item {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      line-height: 1.6;

      .label {
        color: #767676;
        margin-right: 10px;
        flex-shrink: 0;
        font-weight: 400;
      }

      .value {
        color: #303133;
        flex: 1;
        word-break: break-all;
        font-weight: 400;
      }
    }
  }
}

.payment-section {
  .section-content {
    padding: 20px 0;
  }
}

// Element UI 表格样式覆盖
::v-deep .el-table {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  border: 1px solid #CAD6E1;
  border-right: 1px solid #CAD6E1 !important;
  .el-table__cell{
    border-bottom: 1px solid #CAD6E1 !important;
    border-right: 1px solid #CAD6E1 !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
      th {
        border-color: #CAD6E1;
        border-right: 1px solid #CAD6E1 !important;
        padding: 8px 0;
        background: #F5F7FA;
        
        &:last-child {
          border-right: 1px solid #CAD6E1 !important;
        }
      }
    }
  }

  .el-table__body-wrapper {
    border-right: 1px solid #CAD6E1 !important;
    .el-table__body {
      td {
        background-color: #fff;
        padding: 5px 0;
        border-right: 1px solid #CAD6E1 !important;
        
        &:last-child {
          border-right: 1px solid #CAD6E1 !important;
        }
      }
    }
  }

  .el-table__row {
    &:hover {
      background-color: #fff;
    }
  }
}

.YZF-text {
  color: #1a1a1a;
  font-size: 14px;
}

.disabled-pay-text {
  color: #c0c4cc;
  font-size: 14px;
}

.pay-link {
  color: #1890ff;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}

.total-amount {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #EA0000;
  border: 1px solid #CAD6E1;
  border-top: none;
  height: 40px;
  padding: 0 20px;
  .total-label {
    margin-right: 10px;
  }
}

.action-buttons {
  gap: 20px;
  padding-top: 30px;

  .download-btn {
    width: 180px;
    height: 40px;
    background: #1890ff;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;

    &:hover {
      background: #40a9ff;
    }
  }

  .pay-btn {
    width: 180px;
    height: 40px;
    background: linear-gradient(90deg, #ff7a00 0%, #ff9500 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>